<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Presensi</span>
		</div>
		<div class="card-body p-0" v-loading="loading">
			<el-tabs v-model="activeTab" type="border-card" @tab-change="handleTabChange" class="rounded-bottom border-0">
				<el-tab-pane label="Guru" name="presensi-guru" />
				<el-tab-pane label="Tenaga Kependidikan" name="presensi-karyawan" />
				<el-tab-pane label="Siswa" name="presensi-siswa" />
				<el-tab-pane label="Non-GTK" name="presensi-non-gtk" />
				<el-tab-pane label="Rekapitulasi" name="presensi-rekap" />
				<router-view :update-editing="updateEditing" :list-mesin="listMesin" :is-petugas-presensi="isPetugasPresensi" :modal-width="modalWidth" v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div v-if="routeName === 'presensi'" class="row g-3">
							<div class="text-center" v-if="loading">Memuat...</div>
							<div class="text-center" v-else-if="riwayatPresensi.length === 0">Data tidak ditemukan</div>
							<div v-for="rp in riwayatPresensi" :key="rp.type" class="col-12 col-sm-6 col-md-4 col-lg-3" v-else>
								<div class="card">
									<div class="card-header small">
										{{ userTypes[rp.type]?.label || "lainnya" }}
										<router-link :to="{ name: userTypes[rp.type]?.name || 'presensi' }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</div>
									<div class="card-body">
										<div class="d-flex gap-1 align-items-baseline">
											<transition name="slide-up" mode="out-in">
												<span class="fs-5" :key="rp.jumlah">
													{{ rp.jumlah }}
												</span>
											</transition>
											riwayat
										</div>
									</div>
								</div>
							</div>
						</div>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: "PresensiView",
	data() {
		return {
			riwayatPresensi: [],
			userTypes: {
				guru: { label: "Guru", name: "presensi-guru" },
				karyawan: { label: "Tenaga Kependidikan", name: "presensi-karyawan" },
				siswa: { label: "Siswa", name: "presensi-siswa" },
				non_gtk: { label: "Non-GTK", name: "presensi-non-gtk" },
			},
			loading: true,
			activeTab: "",
			listMesin: [],
			isEditing: false,
			modalWidth: "50%",
		};
	},
	computed: {
		isPetugasPresensi() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "presensi"].includes(r.role));
		},
		routeName() {
			return this.$route.name;
		},
	},
	watch: {
		routeName: {
			immediate: true,
			handler(val) {
				if (val !== "presensi") this.loading = false;

				this.activeTab = val;
			},
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.$ws.main.on("log:deleted", this.insertedLog);
		this.$ws.main.on("mesin:inserted", this.insertedMesin);
		this.$ws.main.on("mesin:updated", this.updatedMesin);
		this.$ws.main.on("mesin:deleted", this.deletedMesin);
		this.getJumlahRiwayatPresensi();
		this.getListMesin();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("log:inserted");
		this.$ws.main.off("log:deleted");
		this.$ws.main.off("mesin:inserted");
		this.$ws.main.off("mesin:updated");
		this.$ws.main.off("mesin:deleted");
	},
	methods: {
		insertedLog(data) {
			const idx = this.riwayatPresensi.findIndex((rp) => rp.type === data.type);

			if (idx !== -1) {
				this.riwayatPresensi[idx].jumlah = this.riwayatPresensi[idx].jumlah + 1;
			}
		},
		deletedLog(data) {
			const idx = this.riwayatPresensi.findIndex((rp) => rp.type === data.type);

			if (idx !== -1) {
				this.riwayatPresensi[idx].jumlah = this.riwayatPresensi[idx].jumlah - 1;
			}
		},
		insertedMesin(data) {
			if (!data.aktif) return;

			const newData = {
				mesin_presensi_id: data.mesin_presensi_id,
				nama: data.nama,
				keterangan: data.keterangan,
			};

			const temp = [...this.listMesin];

			temp.push(newData);

			temp.sort((a, b) => {
				return a.nama.localeCompare(b.nama);
			});

			const idx = temp.findIndex((t) => (t.mesin_presensi_id = newData.mesin_presensi_id));

			this.listMesin.splice(idx, 0, newData);
		},
		updatedMesin(data) {
			const oldIdx = this.listMesin.findIndex((m) => m.mesin_presensi_id === data.mesin_presensi_id);

			if (oldIdx !== -1) {
				if (data.status_changed) {
					if (data.aktif === 0) {
						this.listMesin.splice(oldIdx, 1);
						return;
					}
				}

				this.listMesin[oldIdx] = {
					mesin_presensi_id: data.mesin_presensi_id,
					nama: data.nama,
					keterangan: data.keterangan,
				};

				this.listMesin.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});
			}
		},
		deletedMesin(data) {
			const oldIndex = this.listMesin.findIndex((m) => m.mesin_presensi_id === data.mesin_presensi_id);

			if (oldIndex !== -1) this.listMesin.splice(oldIndex, 1);
		},
		handleTabChange(val) {
			this.$router.push({ name: val });
		},
		updateEditing(val) {
			this.isEditing = val;
		},
		beforeLeaveTab() {
			return new Promise((resolve, reject) => {
				if (this.isEditing) {
					reject();
				}
				resolve();
			});
		},
		handleBeforeUnload(e) {
			if (this.isEditing) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "90%";
			else if (w < 768) this.modalWidth = "80%";
			else if (w < 992) this.modalWidth = "60%";
			else if (w < 1200) this.modalWidth = "45%";
			else if (w < 1500) this.modalWidth = "35%";
			else if (w < 1920) this.modalWidth = "30%";
			else this.modalWidth = "25%";
		},
		async getJumlahRiwayatPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/log/count/type");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.riwayatPresensi = data.data.log_presensi_counts;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getListMesin() {
			try {
				const { data } = await this.$defaultApi.get("/mesin/list");

				this.listMesin = data.data.list_mesin_presensi;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
	},
};
</script>

<style scoped></style>
